import { render, staticRenderFns } from "./NewRequest.vue?vue&type=template&id=1a77e06b&scoped=true"
import script from "./NewRequest.vue?vue&type=script&lang=ts"
export * from "./NewRequest.vue?vue&type=script&lang=ts"
import style0 from "./NewRequest.vue?vue&type=style&index=0&id=1a77e06b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a77e06b",
  null
  
)

export default component.exports